// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-TYJ3ZS',
  builtAt: '2026-10-30T18:52:34.899Z'
};
